import { Category } from "@mui/icons-material";

export const locationTypes = [
    { id: 1, title: "Picking"},
    { id: 2, title: "Binning"}
];

export const yesNo = [
    { id: 1, title: "Yes"},
    { id: 0, title: "No"}
];

export const availableDays = [
    { id: 1, title: "Monday" },
    { id: 2, title: "Tuesday" },
    { id: 3, title: "Wednesday" },
    { id: 4, title: "Thursday" },
    { id: 5, title: "Friday" },
    { id: 6, title: "Saturday" },
    { id: 7, title: "Sunday" },
];

export const HelperReminderTasks = [
    { id: 1, title: "Temperature Control", interval: 1, intervalType: 'year', thresholdDays: 30, message: 'every year' },
    { id: 2, title: "Manual Handling", interval: 1, intervalType: 'year', thresholdDays: 30, message: 'every year' },
    { id: 3, title: "Banksman", interval: 1, intervalType: 'year', thresholdDays: 30, message: 'every year' },
    { id: 4, title: "Electric pump truck", interval: 1, intervalType: 'year', thresholdDays: 30, message: 'every year' },
    { id: 5, title: "Work at height", interval: 1, intervalType: 'year', thresholdDays: 30, message: 'every year' },
    { id: 6, title: "PPE", interval: 1, intervalType: 'year', thresholdDays: 30, message: 'every year' },
    { id: 7, title: "Trolley safe systems of work", interval: 1, intervalType: 'year', thresholdDays: 30, message: 'every year' },
    { id: 8, title: "TMS Software", interval: 1, intervalType: 'year', thresholdDays: 30, message: 'every year' },
    { id: 9, title: "Tail lift operation & safety", interval: 1, intervalType: 'year', thresholdDays: 30, message: 'every year' },
    { id: 10, title: "Fridge & Freezer Training", interval: 1, intervalType: 'year', thresholdDays: 30, message: 'every year' },
    { id: 12, title: "End of day product returns & logging", interval: 1, intervalType: 'year', thresholdDays: 30, message: 'every year' },
    { id: 13, title: "Driver Mates Training", interval: 1, intervalType: 'year', thresholdDays: 30, message: 'every year' },
    { id: 14, title: "Three strike rule", interval: 1, intervalType: 'year', thresholdDays: 30, message: 'every year' },
    { id: 15, title: "PPE Agreement", interval: 1, intervalType: 'year', thresholdDays: 30, message: 'every year' },
    { id: 16, title: "Equipment Authorisation", interval: 1, intervalType: 'year', thresholdDays: 30, message: 'every year' },
    { id: 17, title: "Card Spot Agreement", interval: 1, intervalType: 'year', thresholdDays: 30, message: 'every year' },
    { id: 18, title: "Card Spot Form", interval: 1, intervalType: 'year', thresholdDays: 30, message: 'every year' },
    { id: 19, title: "Breathalyser Agreement", interval: 1, intervalType: 'year', thresholdDays: 30, message: 'every year' },
    { id: 20, title: "Breathalyser Form", interval: 1, intervalType: 'year', thresholdDays: 30, message: 'every year' },
    { id: 21, title: "Endorsements Agreement", interval: 1, intervalType: 'year', thresholdDays: 30, message: 'every year' },
    { id: 22, title: "Endorsements Form", interval: 1, intervalType: 'year', thresholdDays: 30, message: 'every year' },
];

export const driverIssuesTypes = [
    { id: "1", title: "Accident" },
    { id: "2", title: "Insubordination" },
    { id: "3", title: "Damage/Loss" },
    { id: "4", title: "Holiday" },
    { id: "5", title: "General Log/Info" }
];

export const driverIssuesActions = [
    { id: "1", title: "Record" },
    { id: "2", title: "Train" },
    { id: "3", title: "Escalate" }
];

export const vehicleDueOptions = [
    { id: 1, title: "Overdue" },
    { id: 2, title: "Due Soon" },
    { id: 3, title: "Upcoming" },
];

export const importTypes = [
    { id: 1, title: "Aisle" },
    { id: 2, title: "Location" },
    { id: 3, title: "Picking Location" },
    { id: 4, title: "Opening Balance" },
];

export const vehicleTypes = [
    { id: 1, title: "3.5 Tonnes", maxWeight: 900, maxPallets: 4, maxPalletWeight: 450, weightThreshold: 50 },
    { id: 2, title: "7.5 Tonnes", maxWeight: 3000, maxPallets: 7, maxPalletWeight: 650, weightThreshold: 50 },
    { id: 3, title: "16 Tonnes", maxWeight: 6000, maxPallets: 12, maxPalletWeight: 650, weightThreshold: 50 },
    { id: 4, title: "18 Tonnes", maxWeight: 7500, maxPallets: 14, maxPalletWeight: 650, weightThreshold: 50 }
];

export const productCategories = [
  { id: 'Ambient', title: 'Ambient' },
  { id: 'Chilled', title: 'Chilled' },
  { id: 'Frozen', title: 'Frozen' },
  { id: 'Others', title: 'Others' },
];

export const productCategoriesByID = [
  { id: 1, title: 'Ambient' },
  { id: 2, title: 'Chilled' },
  { id: 3, title: 'Frozen' },
];

export  const palletTypes = [
    {id:1, title:"Red", color: 'red'},
    {id:2, title:"Blue", color: 'blue'},
    {id:3, title:"Brown", color: 'brown'},
    {id:4, title:"Standard", color: 'green'}
]

export const productSubcategories = [
  { id: 1, title: 'Basting & Marinades', Category: 'Ambient' },
  { id: 2, title: 'Breading', Category: 'Ambient' },
  { id: 3, title: 'Breading', Category: 'Frozen' },
  { id: 4, title: 'Burgers', Category: 'Frozen' },
  { id: 5, title: 'Chicken Products', Category: 'Frozen' },
  { id: 6, title: 'Cleaning & Hygeine Essentials', Category: 'Ambient' },
  { id: 7, title: 'Cooking Essentials', Category: 'Ambient' },
  { id: 8, title: 'Cooking Essentials', Category: 'Chilled' },
  { id: 9, title: 'Cooking Oils & Fats', Category: 'Ambient' },
  { id: 10, title: 'Desserts', Category: 'Ambient' },
  { id: 11, title: 'Desserts', Category: 'Frozen' },
  { id: 12, title: 'Disposable Crockery', Category: 'Ambient' },
  { id: 13, title: 'Disposable Cutlery', Category: 'Ambient' },
  { id: 14, title: 'Disposable Packaging', Category: 'Ambient' },
  { id: 15, title: 'Flour & Breadings', Category: 'Ambient' },
  { id: 16, title: 'Fresh Lamb & Beef', Category: 'Chilled' },
  { id: 17, title: 'Fresh Lamb & Chicken', Category: 'Chilled' },
  { id: 18, title: 'Fresh Poultry-Chicken Legs', Category: 'Chilled' },
  { id: 19, title: 'Fresh Poultry-Fillets', Category: 'Chilled' },
  { id: 20, title: 'Fresh Poultry-Other', Category: 'Ambient' },
  { id: 21, title: 'Fresh Poultry-Other', Category: 'Chilled' },
  { id: 22, title: 'Fresh Poultry-Whole Chicken', Category: 'Chilled' },
  { id: 23, title: 'Fresh Poultry-Wings', Category: 'Chilled' },
  { id: 24, title: 'Fries & Other Potato Products', Category: 'Frozen' },
  { id: 25, title: 'Frozen Poultry- Fillets', Category: 'Frozen' },
  { id: 26, title: 'Fruits', Category: 'Chilled' },
  { id: 27, title: 'Kitchen Essentials', Category: 'Ambient' },
  { id: 28, title: 'Lamb & Beef', Category: 'Frozen' },
  { id: 29, title: 'Pizza Toppings & Other Toppings', Category: 'Ambient' },
  { id: 30, title: 'Pizza Toppings & Other Toppings', Category: 'Chilled' },
  { id: 31, title: 'Pizza Toppings & Other Toppings', Category: 'Frozen' },
  { id: 32, title: 'Sachets', Category: 'Ambient' },
  { id: 33, title: 'sauces', Category: 'Ambient' },
  { id: 34, title: 'Seafood', Category: 'Frozen' },
  { id: 35, title: 'Sides', Category: 'Ambient' },
  { id: 36, title: 'Sides', Category: 'Chilled' },
  { id: 37, title: 'Sides', Category: 'Frozen' },
  { id: 38, title: 'Smoothie Drinks', Category: 'Ambient' },
  { id: 39, title: 'Soft Drinks', Category: 'Ambient' },
  { id: 40, title: 'Syrups', Category: 'Ambient' },
  { id: 41, title: 'Till Labels and Receipt Rolls', Category: 'Ambient' },
  { id: 42, title: 'Vegetarian Products', Category: 'Frozen' },
  { id: 43, title: 'Water Drinks', Category: 'Ambient' },
];

export const userTypes = [
    { id: 1, title: 'Admin' },
    { id: 2, title: 'User' },
];

export const locationCategories = [
    { id: 1, title: 'Ambient' },
    { id: 2, title: 'Chilled' },
    { id: 3, title: 'Frozen' },
];

export const userRolesTypes = [
    { id: 1, title: 'Routing', },
    { id: 2, title: 'Finance', },
    { id: 4, title: 'Warehouse Manager' },
    { id: 5, title: 'Warehouse User' },
    { id: 6, title: 'Sales Manager' },

];

export const deliveryStatuses = [
    { id: 1, title: "Customer Over Ordered" },
    { id: 2, title: "Customer Ordered Wrong Item" },
    { id: 3, title: "Damaged In Transit" },
    { id: 4, title: "Delivery Fee Discount" },
    { id: 5, title: "Full Delivery Return" },
    { id: 6, title: "Invoice Error" },
    { id: 7, title: "Item Discount" },
    { id: 8, title: "Loading Error" },
    { id: 9, title: "Pricing Error" },
    { id: 10, title: "Short Dated" },
    { id: 11, title: "Shortage" },
    { id: 12, title: "Delivered" },
];

export const StockReturnReasons = [
    { id: 1, title: "Returned to Stock" },
    { id: 2, title: "Written Off" },
    { id: 3, title: "Missing" },
];

export const reasonOptions = [
        { label: "Shortage", value: 1 },
        { label: "Damaged", value: 2 },
        { label: "Expired", value: 3 },
        // { label: "Other", value: 4 }
    ];

export const RolePermissions = {
    1: [
        "/dashboard",
    ],
    2: [
    "/dashboard",
    "/rosters",
    "/rosters/:id",
    "/helpers",
    "/helpers/:id",

    "/helper_reminder",
    "/helper_reminder/new",
    "/helper_reminder/:id",
    "/helper_reminder/resolve/:id",

    "/aisles",
    "/aisles/:id",
    "/locations",
    "/locations/:id",

    "/products",
    "/products/:id",
    "/product-locations",
    "/product-locations/:id",

    "/cycle-counts",
    "/cycle-counts/:id",
    "/cycle-counts/update/:id",

    "/stocks",
    "/stocks/route-packing",
    "/stocks/route-picking",
    "/stocks/receive-stock",
    "/stocks/receive-returned-stock",
    "/stocks/new-stock",
    "/stocks/returned-stock",
    "/stocks/dispatch-stock",
    "/stocks/transfer-stock",
    "/stocks/route-returns",
    "/stocks/route-returns-restock",
    "/stocks/inventory-adjustments",

    "/scan",

    "/migrations",
     "/transaction-po",
    "/transaction-po/:id",
    "/transaction-so",
    "/transaction-so/:id",
    "/transaction-cn",
    "/transaction-cn/:id",
    "/transaction-ob",
    "/transaction-ob/:id",

    "/reports-stock-trail",
    "/reports-batches",
  ],
  4: [
    "/dashboard",
    "/rosters",
    "/rosters/:id",
    "/helpers",
    "/helpers/:id",

    "/helper_reminder",
    "/helper_reminder/new",
    "/helper_reminder/:id",
    "/helper_reminder/resolve/:id",

    "/aisles",
    "/aisles/:id",
    "/locations",
    "/locations/:id",

    "/products",
    "/products/:id",
    "/product-locations",
    "/product-locations/:id",

    "/cycle-counts",
    "/cycle-counts/:id",
    "/cycle-counts/update/:id",

    "/stocks",
    "/stocks/route-packing",
    "/stocks/route-picking",
    "/stocks/receive-stock",
    "/stocks/receive-returned-stock",
    "/stocks/new-stock",
    "/stocks/returned-stock",
    "/stocks/dispatch-stock",
    "/stocks/transfer-stock",
    "/stocks/route-returns",
    "/stocks/route-returns-restock",
    "/stocks/inventory-adjustments",


    "/scan",

    "/migrations",
     "/transaction-po",
    "/transaction-po/:id",
    "/transaction-so",
    "/transaction-so/:id",
    "/transaction-cn",
    "/transaction-cn/:id",
    "/transaction-ob",
    "/transaction-ob/:id",

    "/reports-stock-trail",
    "/reports-batches",
  ],
  5: [
    "/dashboard",
    "/stocks",
    "/stocks/route-packing",
    "/stocks/route-picking",
    "/stocks/receive-stock",
    "/stocks/receive-returned-stock",
    "/stocks/new-stock",
    "/stocks/returned-stock",
    "/stocks/dispatch-stock",
    "/stocks/transfer-stock",
    "/stocks/route-returns",
    "/stocks/route-returns-restock",
    "/stocks/inventory-adjustments",


    "/products",
    "/products/:id",
    "/product-locations",
    "/product-locations/:id",

    "/cycle-counts",
    "/cycle-counts/:id",
    "/cycle-counts/update/:id",
    "/transaction-po",
    "/transaction-po/:id",
    "/transaction-so",
    "/transaction-so/:id",
    "/transaction-cn",
    "/transaction-cn/:id",
    "/transaction-inventory",
    "/transaction-inventory/:id",

    "/reports-batches",
  ],

};


